export default function fs_to_ms(velocity_in_fs:number):number {
  return velocity_in_fs / 0.3048;
}
